import React, { useRef } from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { ProjectModel } from '../../../Models/ProjectModel';
import useCan from '../../../Hooks/useCan';
import './styles.css';
import { Chart, CategoryScale, LinearScale, BarElement, Title, Tooltip } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Bar } from 'react-chartjs-2';
// Registra os módulos necessários
Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, ChartDataLabels);
interface IBarChartComponentProps {
    companyId: string;
    projects: ProjectModel[];
}
export default function BarChartComponent({ companyId, projects }: IBarChartComponentProps) {
    const canView = useCan({
        rolesCan: ['HumanResources', 'Dossie', 'Financial', 'FINNSeguros - Extern'],
    });
    const canNotView = useCan({
        rolesCan: ['Internal', 'TechnicianLimited', 'Technician', 'Dossie', 'Financial'],
    });
    const data = {
        labels: projects.map((project) =>
            project.name.length > 10 ? `${project.name.substring(0, 12)}...` : project.name
        ),
        datasets: [
            {
                label: 'Orçamento dos Projetos (R$)',
                data: projects.map((project) => project.budget),
                backgroundColor: '#5B8FF9',
                borderRadius: 0,
                barThickness: 30,

            },
        ],
    };
    const options: any = {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y' as const,
        layout: {
            padding: {
                right: 100,
            },
        },
        plugins: {
            tooltip: {
                enabled: !canNotView,
                callbacks: {
                    label: (context: any) => `R$ ${context.raw.toLocaleString()}`,
                },
            },
            legend: { display: false },
            datalabels: {
                anchor: 'start',
                align: 'end',
                offset: 5,
                clip: false,
                style:{},
                formatter: (value: number) => `R$ ${value.toLocaleString()}`,
                font: { size: 13, family: 'Century Gothic', weight: 'bold' },
                color: '#FFFFFF',
            },
        },
        scales: {
            x: {
                display: false,
                grid: { display: false },
            },
            y: {
                ticks: {
                    font: { family: 'Century Gothic', size: 14 },
                    color: '#000',
                    padding: 10,
                },
                grid: { display: false },
            },
        },
    };
    return (
        <div className="bar-chart-container">
            <h2 className="chart-title">Orçamento dos Projetos (R$)</h2>
            <div style={{ height: '350px' }}>
                <Bar data={data} options={options} />
            </div>
            {!canView && (
                <div className="button-container">
                    <Button type="primary" className="see-more-button">
                        <Link to={`/recommendations/${companyId}`}>Veja Mais...</Link>
                    </Button>
                </div>
            )}
        </div>
    );
}